import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './styles.module.css';

const TrilhaNavegacao = () => {
  const { pathname } = useLocation();
  
  // Divide o path e filtra partes vazias
  const segments = pathname.split('/').filter(Boolean);

  // Reconstroi os paths progressivamente
  let accumulatedPath = '';
  const breadcrumbs = segments.map((segment, index) => {
    accumulatedPath += `/${segment}`;
    return {
      path: accumulatedPath,
      label: segment, // Fallback opcional
      isLast: index === segments.length - 1
    };
  });

  return (
    <div className={styles.trilha}>
      <Link to="/" className={styles.trilhaLink}>home</Link>
      
      {breadcrumbs.map(({ path, label, isLast }) => (
        <span key={path}>
          {isLast ? (
            <span className={styles.trilhaAtual}>{label}</span>
          ) : (
            <Link to={path} className={styles.trilhaLink}>{label}</Link>
          )}
        </span>
      ))}
    </div>
);
};

export default TrilhaNavegacao;